import type { FrameRangeT } from '../../../common/types/types';
import type { AnnotationLabelT } from '../../../common/types/types';
import type { CARDINALITY, DIRECTIONALITY, FRAME_FIELD, TEMPORAL_SCOPE } from '../constants';
export type OutputRelationshipT = {
  id: string;
  labelName: string;
  sourceAnnotationId: string;
  targetAnnotationId: string;
  frameRanges: Array<FrameRangeT>;
};
export type RelationshipT = Omit<OutputRelationshipT, 'labelName'> & {
  relationshipLabel: RelationshipLabelDefinitionT;
};
export type RelationshipStoreT = {
  [relationshipId: string]: OutputRelationshipT;
};
export type RelationshipStoreWithLabelDataT = {
  [relationshipId: string]: RelationshipT;
};
export type TemporalScopeT = (typeof TEMPORAL_SCOPE)[keyof typeof TEMPORAL_SCOPE];
export type TemporalConstraintsT = {
  temporalScope?: TemporalScopeT;
  temporalContainment?: boolean;
};
export type CardinalityT = (typeof CARDINALITY)[keyof typeof CARDINALITY];
export type CardinalityConstraintsT = {
  cardinality?: CardinalityT;
  inverseCardinality?: CardinalityT;
};
export type ClassConstraintsT = {
  source: string[];
  target: string[];
};
export type DirectionalityT = (typeof DIRECTIONALITY)[keyof typeof DIRECTIONALITY];
export type RelationshipLabelDefinitionT = {
  name: string;
  classConstraints: ClassConstraintsT;
  temporalConstraints?: TemporalConstraintsT;
  cardinalityConstraints?: CardinalityConstraintsT;
  minInstances?: number;
  maxInstances?: number;
  // default is Directed
  directionality: DirectionalityT;
  relationshipLabelName: string;
};
export type FrameFieldT = (typeof FRAME_FIELD)[keyof typeof FRAME_FIELD];
export type SelectOptionT = {
  label: string;
  id: string;
  annotationLabel?: AnnotationLabelT;
};
export type DraftFrameRangeT = {
  startFrame?: number;
  endFrame?: number;
};
export type DraftRelationshipT = {
  id: string;
  targetId: string;
  frameRanges: DraftFrameRangeT[];
};
export type DraftRelationshipsMapT = Record<string, DraftRelationshipT>;